import React, { Component } from 'react';

export default class SearchForm extends Component {
    render() {
        return <div />;
        return (
            <form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
                <div className="form-group mb-0">
                    <div className="input-group input-group-alternative">
                        <div className="input-group-prepend">
                            <span className="input-group-text">
                                <i className="fas fa-search" />
                            </span>
                        </div>
                        <input className="form-control" placeholder="Buscar" type="text" />
                    </div>
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Layout/Topbar/SearchForm.js